'use strict';

var angular = require('angular');
var toastr = require('toastr');
var _ = require('lodash');
var FaresOptimizerApproveModalController = function FaresOptimizerApproveModalController($timeout, $scope, criteriaRuleService, featureToggleService) {
  $scope.notes = '';
  function getTodayDate() {
    return criteriaRuleService.getDefaultFieldValue('utc2date').startOf('day');
  }
  $scope.uiDateRangeFrom = getTodayDate();
  $scope.effectiveMinDate = getTodayDate();
  $scope.disableApprovalEffectiveDate = 'ADAPTIVE' === $scope.approveModalData.recommendMode && featureToggleService.isEnabled('ADAPTIVE_APPROVE_ALL_LADDERS');
  $scope.handleApprove = function () {
    $scope.approveModalData.effectiveDate = $scope.uiDateRangeFrom;
    $scope.approveModalData.authorizationNotes = $scope.notes;
    $scope.approveModalData.ladderIds = $scope.fareRecommendationRecordKeyList;
    $scope.handleModalHideAndResetItsState();
    $scope.approveCallback();
  };
  $scope.isFormDisabled = function () {
    return $scope.uiDateRangeFrom === undefined || $scope.approveModalData.maxAllowedApprovalDate !== undefined && $scope.approveModalData.maxAllowedApprovalDate.isBefore($scope.uiDateRangeFrom);
  };
  $scope.showMaxApprovalDateMessage = function () {
    return $scope.approveModalData.maxAllowedApprovalDate !== undefined;
  };
  $scope.showNoteForNewOrCancelFares = function (rows) {
    if (_.isUndefined($scope.isRecommendationScreen) || !$scope.isRecommendationScreen) {
      $scope.note = 'Review new/cancelled fares ladders in the fare analysis screen as it is recommended to approve the related new & cancelled fares together';
      return true;
    }
    if (_.isUndefined($scope.allRowsSelected) || $scope.allRowsSelected) {
      return false;
    }
    if (!_.isEmpty(rows)) {
      var newActionCodePresent = _.some(rows, {
        'allNewOrCancelActionCode': 'N'
      });
      var cancelActionCodePresent = _.some(rows, {
        'allNewOrCancelActionCode': 'X'
      });
      var newActionCodePresentInUnSelectedRows = _.some($scope.userNotSelectedRows, {
        'allNewOrCancelActionCode': 'N'
      });
      var cancelActionCodePresentInUnSelectedRows = _.some($scope.userNotSelectedRows, {
        'allNewOrCancelActionCode': 'X'
      });
      if (newActionCodePresent && cancelActionCodePresent && (newActionCodePresentInUnSelectedRows || cancelActionCodePresentInUnSelectedRows)) {
        $scope.note = 'Review new & cancelled fares ladders as it is recommended to approve the related new & cancelled fares together';
        return true;
      }
      if (newActionCodePresent && cancelActionCodePresentInUnSelectedRows) {
        $scope.note = 'Review cancelled fares ladders as it is recommended to approve the related new & cancelled fares together';
        return true;
      }
      if (cancelActionCodePresent && newActionCodePresentInUnSelectedRows) {
        $scope.note = 'Review new fares ladders as it is recommended to approve the related new & cancelled fares together';
        return true;
      }
    }
    return false;
  };
  $scope.handleModalHideAndResetItsState = function () {
    $scope.note = '';
    $scope.notes = '';
    $scope.uiDateRangeFrom = getTodayDate();
    angular.element('body').removeClass('modal-open');
    angular.element('.modal-backdrop').remove();
  };
};
FaresOptimizerApproveModalController.$inject = ['$timeout', '$scope', 'CriteriaRuleService', 'FeatureToggleService'];
module.exports = FaresOptimizerApproveModalController;